export const indivisual_results_request = 'indivisual_results_request'
export const indivisual_results_success = 'indivisual_results_success'
export const indivisual_results_failure = 'indivisual_results_failure'
export const data_loaded_off = 'data_loaded_off'
